export type Id = number;

export type FoundContext = 'report' | 'found_on_street' | 'brought_by_rescuer';
export type VisibilityDays = 15 | 30 | 60 | 90;

export interface RescuedAnimalPhoto {
  id?: Id;
  rescuedAnimalId?: Id;
  url: string;
  isPrimary: boolean;
  createdAt?: string;
}

export interface RescuedAnimal {
  id?: Id;
  shelterId: Id;
  intakeDate: string;
  speciesId: Id;
  speciesLabel?: string;
  sexId?: Id;
  sexLabel?: string;
  sizeId?: Id;
  sizeLabel?: string;
  conditionId: Id;
  conditionLabel?: string;
  foundArea: string;
  foundContext: FoundContext;
  description: string;
  visibilityDays: VisibilityDays;
  expiresAt?: string;
  statusId?: Id;
  statusLabel?: string;
  claimedAt?: string;
  createdBy?: Id;
  createdAt?: string;
  updatedAt?: string;
  deletedAt?: string | null;
  photos?: RescuedAnimalPhoto[];
}

export interface RescuedAnimalsListParams {
  page?: number;
  pageSize?: number;
  [key: string]: any;
}

export type RescuedAnimalStatusCode = 'published' | 'claimed' | 'archived';

export const FOUND_CONTEXT_OPTIONS: Array<{value: FoundContext; label: string}> = [
  {value: 'report', label: 'Denuncia'},
  {value: 'found_on_street', label: 'Encontrado en la calle'},
  {value: 'brought_by_rescuer', label: 'Traído por rescatista'},
];

export const VISIBILITY_DAYS_OPTIONS: VisibilityDays[] = [15, 30, 60, 90];
